import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const RadioFormLabel = styled(FormControlLabel)`
  color: ${({ theme }) =>
    // @ts-expect-error fix
    theme.palette.black};
  margin: ${({ theme }) => theme.spacing(0)};
`;
